import StyleToObject from '../cjs/index.js';

// ensure compatibility with rollup umd build
export default StyleToObject.default || StyleToObject;
